import { Utils } from 'versafleet-core';
import * as Sentry from '@sentry/browser';

const { request } = Utils.RequestHelper;

function receiveConstants(result) {
  return {
    type: 'RECEIVE_CONSTANTS',
    constants: result,
  };
}

function receiveCountries(result) {
  return {
    type: 'RECEIVE_COUNTRIES',
    countries: result.countries,
  };
}

function fetchList() {
  return (dispatch) => {
    request('/constants', {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveConstants(result));
        return result;
      })
      .catch((error) => { Sentry.captureException(error); });
  };
}

function fetchCountryList() {
  return (dispatch) => {
    request('/constants/countries', {
      method: 'GET',
    })
      .then((result) => {
        dispatch(receiveCountries(result));
        return result;
      })
      .catch((error) => { Sentry.captureException(error); });
  };
}

export default {
  fetchList,
  fetchCountryList,
};
